import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-forest text-center" data-id="element-138" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-cream-light" data-id="element-139" data-mp="3gfsja2r5qci8">
        © Pickleball Instructor Ready 2026 — All Rights Reserved.
      </p>
      <p className="text-xs text-cream/70 mt-2" data-id="element-140" data-mp="32p5mig4yiwos">
        Digital teaching material for instructors. Results depend on how the system is
        applied on court.
      </p>
    </footer>;
}